import React,{ useRef, useEffect, useState } from 'react'
import silver from '../../assets/silver.svg'
import gold from '../../assets/gold.svg'
import check from '../../assets/check.svg'
import cross from '../../assets/cross.svg'
import redirect from '../../assets/redirect.svg'
import useLocation from "../../utils/Location";
import { getWhatsappLink } from "../../utils/getWhatsappNumber";
const Yearly = ({currency}) => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);
    const silverplan = [
        {
            allow: true,
            content: (
                <p >
                    45 Themes Available
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1 Business
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Appointments
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Contacts
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 Staff Users
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1 Subdomain
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1 PWA
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    QR Code
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1 PVC Card
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1 Notification<span>/month</span>  on Dashboard
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             Chat and Email support
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* 100MB Data Storage Limit */}
                    100MB Storage
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Marketplace Listing
                </p>
            )
        },
        {
            // allow: true,
            allow: false,
            content: (
                <p >
                    {/* 5 Marketplace Leads every month */}
                    Marketplace Leads                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    Dedicated RM Support
                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    {/* Advanced Ecommerce Store */}
                    Ecommerce Store
                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    Premium UI
                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    Dedicated Leads
                </p>
            )
        },
        // {
        //     allow: false,
        //     content: (
        //         <p >
        //             WhatsApp integration
        //         </p>
        //     )
        // },
            {
            allow: true,
            content: (
                <p >
                    {/* Google Review Card <span>(Extra charges applicable)</span> */}
                    Google Review Card <span>(Extra cost)</span>
                </p>
            )
        },
          {
            allow: false,
            content: (
                <p >
                    Marketing Consultation
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* App & Play Store Submission <span>(Extra charges applicable)</span> */}
                    App Submission (Playstore/Appstore) <span>(3 MONTHS NECESSARY)</span>
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* Metal Card <span>({currency?.currencySymbol}2000 + Plan Price)</span> */}
                    Metal Card {currency?.currencyName === "Dirhams" ? "" :<span>({currency?.currencySymbol}2000 + Plan Price)</span>}
                </p>
            )
        },
    ]
    const goldplan = [
        {
            allow: true,
            content: (
                <p >
                    45 Themes Available
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    2 Businesses
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Appointments
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    1000 Contacts
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    5 Staff Users
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    2 Subdomains
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    2 PWAs
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    QR Code
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    2 PVC Cards
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    15 Notifications<span>/month</span> on Dashboard
                </p>
            )
        },
        // {
        //     allow: true,
        //     content: (
        //         <p >
        //             Chat and Email support
        //         </p>
        //     )
        // },
        {
            allow: true,
            content: (
                <p >
                    {/* 250MB Data Storage Limit */}
                    250MB Storage
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    Marketplace Listing
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* 10 Marketplace Leads every month */}
                    Basic Marketplace Leads
                </p>
            )
        },
        {
            // allow: true,
            allow: false,
            content: (
                <p >
                    Dedicated RM Support
                </p>
            )
        },
        {
            // allow: true,
            allow: false,
            content: (
                <p >
                    {/* Advanced Ecommerce Store */}
                    Ecommerce Store
                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    Premium UI
                </p>
            )
        },
        {
            allow: false,
            content: (
                <p >
                    Dedicated Leads
                </p>
            )
        },
        // {
        //     allow: false,
        //     content: (
        //         <p >
        //             WhatsApp integration
        //         </p>
        //     )
        // },
         {
            allow: true,
            content: (
                <p >
                    {/* Google Review Card <span>(Extra charges applicable)</span> */}
                    Google Review Card <span>(Extra cost)</span>
                </p>
            )
        },
         {
            allow: false,
            content: (
                <p >
                    Marketing Consultation
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* App & Play Store Submission <span>(Extra charges applicable)</span> */}
                    App Submission (Playstore/Appstore) <span>(3 MONTHS NECESSARY)</span>
                </p>
            )
        },
        {
            allow: true,
            content: (
                <p >
                    {/* Metal Card <span>({currency?.currencySymbol}2000 + Plan Price)</span> */}
                    Metal Card {currency?.currencyName === "Dirhams" ? "" :<span>({currency?.currencySymbol}2000 + Plan Price)</span>}
                </p>
            )
        },
    ]
    const containerRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)
  
    useEffect(() => {
      const container = containerRef.current
  
      const handleScroll = () => {
        const boxes = Array.from(container.children)
        const center = container.scrollLeft + container.offsetWidth / 2
  
        let closestIndex = 0
        let closestDistance = Infinity
  
        boxes.forEach((box, i) => {
          const boxCenter = box.offsetLeft + box.offsetWidth / 2
          const distance = Math.abs(center - boxCenter)
          if (distance < closestDistance) {
            closestDistance = distance
            closestIndex = i
          }
        })
  
        setActiveIndex(closestIndex)
      }
  
      container.addEventListener("scroll", handleScroll, { passive: true })
      return () => container.removeEventListener("scroll", handleScroll)
    }, [])
    const silverpricing = currency?.currencyName === "Dirhams" ? "AED 40" : `${currency?.currencySymbol}999.00`;
    const goldpricing = currency?.currencyName === "Dirhams" ? "AED 80" : `${currency?.currencySymbol}2999.00`;
    const plans = [
        { name: "Silver", price: silverpricing, plan: silverplan, img: silver },
        { name: "Gold", price: goldpricing, plan: goldplan, img: gold }
      ]
    
      return (
        <div id="plan" className="plancontainer" ref={containerRef}>
          {plans.map((p, i) => (
            <div key={i} className={`planbox ${activeIndex === i ? "active" : ""}`}>
              <div className="plannamediv">
                <div className="planimgbox">
                  <img src={p.img} alt={p.name} />
                </div>
                <h3 className="planname">{p.name}</h3>
              </div>
              <h4 className="planprice">
                {p.price}<span>{currency?.currencyName === "Dirhams" ? "+VAT/yearly":"/yearly"}</span>
              </h4>
              <ul>
                {p.plan.map((item, index) => (
                  <li key={index} className='planlist'>
                    <img src={item.allow ? check : cross} alt="" /> {item.content}
                  </li>
                ))}
              </ul>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className='ctawhatsapp'>
              <p type="button" className="getstarted">
                Get Started <span><img src={redirect} alt="redirect" /></span>
              </p>
              </a>
            </div>
          ))}
        </div>
      )
    }
export default Yearly